/**
 * Holds all the User data mutation methods
 */

export default {
  SPINNER_STATE(state, loading) {
    state.loading = loading;
  },
};
